// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer-col {
  flex: auto;
  padding: 25px;
  flex-direction: column;
}
.logo-col {
  background-color: #b01e3f;
  /* max-width: 100%; */
}
.content-col {
  background-color: #12498a;
  color: #fff;
}
.flex-container {
  display: flex;
}
.footer-row {
  margin-bottom: 10px;
}
.map-icon {
  margin-right: 4px;
}
.social-icon {
  background-color: #12498a;
  color: #fff;
  border-left: 1px solid white;
}
.list {
  list-style: none;
  display: flex;
}
.footer-info {
  list-style: none;
  display: flex;
  padding-left: 0px;
}
.p-25 {
  padding: 25px;
}
.ui-li-first-child {
  margin-right: 10px;
}
.li-child {
  margin: 0 10px;
}
.footer-row1 {
  margin-bottom: 10px;
}
.address {
  color: white;
  font-family: 'Noto Serif', serif;
  font-size: 20px;
  font-style: italic;
}
.footer-row2 {
  margin-top: 20px;
}
.footer-info li:first-child {
  padding-left: 0;
}
.footer-info li {
  padding: 0 15px;
  border-right: 2px solid #9f8b62;
}
.footer-info li:last-child {
  border-right: 0;
}
.footer-info li p svg {
  margin-right: 8px;
}
.address svg {
  margin-right: 8px;
}
.social-icon .list {
  padding-left: 0px;
  display: inline-block;
}
.social-icon .li-child {
  float: left;
  margin: 0 10px 0 0 !important;
}
.footer-info p {
  margin-bottom: 0px;
  line-height: 18px;
}
.mt-20{
  margin-top:20px;
}
@media screen and (max-width: 1300px)
{
.footerresp {
  width: 100%;
  flex: 0 0 100%;
  max-width: 100%;
  text-align: center;
}
.content-col.footerresp {
  border-top: 1px solid#fff;
  border-bottom: 1px solid#fff;
}
.footer-info {
  margin-bottom: 0px;
  display: inline-block;
}
.social-icon .list {
  padding-left: 0px;
  display: inline-block;
  margin-bottom: 0px;
}
.footer-info li {
  padding: 0 15px;
  padding-left: 15px;
  border-right: 0px solid#9f8b62;
  display: inline-block;
}
.social-icon {
border-left: 0px solid white;
}
}`, "",{"version":3,"sources":["webpack://./src/footer/Footer.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,4BAA4B;AAC9B;AACA;EACE,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,gCAAgC;EAChC,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,+BAA+B;AACjC;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;;AAEA;EACE,WAAW;EACX,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,8BAA8B;EAC9B,qBAAqB;AACvB;AACA;AACA,4BAA4B;AAC5B;AACA","sourcesContent":[".footer-col {\n  flex: auto;\n  padding: 25px;\n  flex-direction: column;\n}\n.logo-col {\n  background-color: #b01e3f;\n  /* max-width: 100%; */\n}\n.content-col {\n  background-color: #12498a;\n  color: #fff;\n}\n.flex-container {\n  display: flex;\n}\n.footer-row {\n  margin-bottom: 10px;\n}\n.map-icon {\n  margin-right: 4px;\n}\n.social-icon {\n  background-color: #12498a;\n  color: #fff;\n  border-left: 1px solid white;\n}\n.list {\n  list-style: none;\n  display: flex;\n}\n.footer-info {\n  list-style: none;\n  display: flex;\n  padding-left: 0px;\n}\n.p-25 {\n  padding: 25px;\n}\n.ui-li-first-child {\n  margin-right: 10px;\n}\n.li-child {\n  margin: 0 10px;\n}\n.footer-row1 {\n  margin-bottom: 10px;\n}\n.address {\n  color: white;\n  font-family: 'Noto Serif', serif;\n  font-size: 20px;\n  font-style: italic;\n}\n.footer-row2 {\n  margin-top: 20px;\n}\n.footer-info li:first-child {\n  padding-left: 0;\n}\n.footer-info li {\n  padding: 0 15px;\n  border-right: 2px solid #9f8b62;\n}\n.footer-info li:last-child {\n  border-right: 0;\n}\n.footer-info li p svg {\n  margin-right: 8px;\n}\n.address svg {\n  margin-right: 8px;\n}\n.social-icon .list {\n  padding-left: 0px;\n  display: inline-block;\n}\n.social-icon .li-child {\n  float: left;\n  margin: 0 10px 0 0 !important;\n}\n.footer-info p {\n  margin-bottom: 0px;\n  line-height: 18px;\n}\n.mt-20{\n  margin-top:20px;\n}\n@media screen and (max-width: 1300px)\n{\n.footerresp {\n  width: 100%;\n  flex: 0 0 100%;\n  max-width: 100%;\n  text-align: center;\n}\n.content-col.footerresp {\n  border-top: 1px solid#fff;\n  border-bottom: 1px solid#fff;\n}\n.footer-info {\n  margin-bottom: 0px;\n  display: inline-block;\n}\n.social-icon .list {\n  padding-left: 0px;\n  display: inline-block;\n  margin-bottom: 0px;\n}\n.footer-info li {\n  padding: 0 15px;\n  padding-left: 15px;\n  border-right: 0px solid#9f8b62;\n  display: inline-block;\n}\n.social-icon {\nborder-left: 0px solid white;\n}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
